import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/Common/Services/login.service';
import { MatDialog } from '@angular/material';
import { LoginComponent } from '../login/login.component';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-healthsense-platinum',
  templateUrl: './healthsense-platinum.component.html',
  styleUrls: ['./healthsense-platinum.component.css']
})
export class HealthsensePlatinumComponent implements OnInit {

  selected = 'ENG';


  
  constructor(public loginservice:LoginService, private toastr: ToastrService, public dialog: MatDialog,private router:Router) {


   }

   ngOnInit() {
  }
  goBack() {
    window.history.back();
  }

  download(){
    var link ="./assets/images/Healthplatinum.pdf";
    window.open(link);
  }
  
  contactclick(){
    this.router.navigate(["/contactUs"])
  }
   openLoginDialog(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
        panelClass: 'loginpopupbox'
    });
  }

}





